import Button from '../../../components/base/Button';

export default function HeroSection() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="home" 
      className="min-h-screen flex items-center justify-center relative bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.3)), url('https://static.readdy.ai/image/40b0e54abc8a92bbb8d049c8a84106ef/c793b50f40bcf41658d6ec7cae3b7b90.png')`
      }}
    >
      <div className="max-w-7xl mx-auto px-6 py-20">
        <div className="text-center">
          <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            Golden Twin Towers
            <span className="block text-[#C8A654] text-3xl lg:text-4xl mt-2">GTT Ltd.</span>
          </h1>
          
          <p className="text-xl lg:text-2xl text-gray-100 mb-4 font-medium">
            Your Strategic Gateway to K-Beauty's Global Future
          </p>
          
          <p className="text-lg text-gray-200 mb-8 leading-relaxed max-w-4xl mx-auto">
            Delivering Manufacturing Excellence and Brand Authority to the World Market through innovative Korean beauty solutions and premium OEM/ODM services.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              onClick={scrollToContact}
              size="lg"
              className="shadow-2xl"
            >
              <i className="ri-phone-line mr-2"></i>
              Contact Our Team
            </Button>
            <Button 
              variant="secondary"
              size="lg"
              onClick={() => {
                const element = document.getElementById('brands');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="bg-white/20 text-white border-2 border-white/30 hover:bg-white/90 hover:text-gray-900 backdrop-blur-sm"
            >
              <i className="ri-arrow-down-line mr-2"></i>
              Explore Services
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
